import React from 'react'
// import ScrollTop from 'react-scrolltop-button'

import SocialLinks from '../components/sociallinks/SocialLinks'
import NavBar from '../components/navbar/NavBar'
import MainImages from '../components/mainimages/MainImages'
import StarParalax from '../components/starparalax/StarParalax'
import TimeLine from '../components/timeline/TimeLine'
import ContactUs from '../components/contactus/ContactUs'
import Footer from '../components/footer/Footer'
import ScrollTop from '../components/scrolltop/ScrollTop'


import Devider from '../assets/path-1.svg'
import DeviderSecond from '../assets/path-2.svg'


const Home = () => {
    return (
        <>
            <SocialLinks />
            <NavBar />
            <StarParalax />
            <div className="divider">
                <img src={Devider} alt="" />
            </div>
            <MainImages />
            <div className="divider">
                <img src={DeviderSecond} alt="" />
            </div>
            <TimeLine />
            <div className="divider">
                <img src={Devider} alt="" />
            </div>
            <ContactUs />
            <Footer />
            <ScrollTop />
        </>
    )
}

export default Home
